import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import HeaderRender from "../../components/UI/Table/HeaderRender";
import ItemRender from "../../components/UI/Table/ItemRender";
import HeaderContainer from "../../components/UI/‌Header/HeaderContainer";
import dayjs from "dayjs";
import ShowPaginationData from "../../components/UI/TableView/ShowPaginationData";
import { showInIQD } from "../../customFunction/Numeral/CurrencyFormat";
import { IoAdd } from "react-icons/io5";
import RequestModal from "../../components/utils/RequestModal";

export default function ExpensesScreen() {
  const { columns, id, label, url, href } = {
    id: 'expenses', label: 'expenses',
    href: '/expenses',
    columns: [{ label: '#', value: a => a._id },
    { label: 'name', sort: 'name', classnames: () => 'font-[Montserrat]', value: (a) => a.name },
    { label: 'price', sort: 'price', value: (a) => showInIQD(a.price, 'USD') + ' - ' + showInIQD(a.iqd) },
    { label: 'date', sort: 'createdAt', value: (a) => dayjs(a.createdAt).format('YYYY-MM-DD HH:mm') },
    ],
    url: (centerId) => `/expenses?startDate=${dayjs().format('YYYY-MM-DD')}&endDate=${dayjs().format('YYYY-MM-DD')}&` + centerId,
  }
  const history = useHistory()
  
  const onPressCreateUser = () => {
    history.push(window.location.pathname + '/0')
  }
  
  return (
    <div className="flex flex-col items-center w-full bg-white">

      <ShowPaginationData defaultSort={[{ sort: 'createdAt', sortBy: 1 }]} hrefId={null} onClickItem={(_id) => {}} rightButton={<div className="cursor-pointer" >
        <IoAdd size={40} onClick={onPressCreateUser} />
      </div>} columns={columns} href={href} id={id} label={label} url={url} />
    </div>
  );
}
